import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";

import { Action, Selector, StateContext, State } from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { tap, finalize, catchError } from "rxjs";

import { PermissionsService } from "../../services/permissions/permissions.service";
import { Permission } from "../../models/permission/permission.mode";
import { Permissions } from "./permissions.actions";

export interface PermissionsStateModel {
	all: Permission[];
	byUser: Record<number, Permission[]>;
	loadingAll: boolean;
	loadingByUser: boolean;
}

@State<PermissionsStateModel>({
	name: "permissionsstate",
	defaults: {
		all: [],
		byUser: {},
		loadingAll: false,
		loadingByUser: false,
	},
})
@Injectable()
export class PermissionsState {
	constructor(private permissionsService: PermissionsService) {}

	@Selector()
	static getAllPermissions(state: PermissionsStateModel) {
		return state.all;
	}

	@Selector()
	static getUserPermissions(state: PermissionsStateModel) {
		return (userId: number) => state.byUser[userId] ?? [];
	}

	@Action(Permissions.FetchAll)
	fetchAllPermissions(ctx: StateContext<PermissionsStateModel>) {
		ctx.patchState({ loadingAll: true });
		return this.permissionsService.fetchPermissions().pipe(
			tap((returnData: any) => {
				let permissions: Permission[];
				permissions = returnData.data;

				ctx.patchState({
					...ctx.getState(),
					all: permissions,
				});
			}),
			finalize(() => {
				ctx.patchState({
					loadingAll: false,
				});
			})
		);
	}

	@Action(Permissions.FetchUserPermissions)
	fetchUserPermissions(ctx: StateContext<PermissionsStateModel>, action: Permissions.FetchUserPermissions) {
		ctx.patchState({
			loadingByUser: true,
		});
		return this.permissionsService.fetchPermissionsByUser(action.userId).pipe(
			tap((returnData: any) => {
				let userPermissions: Permission[];
				userPermissions = returnData.data;

				ctx.patchState({
					byUser: {
						...ctx.getState().byUser,
						[action.userId]: userPermissions,
					},
				});
			}),
			finalize(() => {
				ctx.patchState({
					loadingByUser: false,
				});
			})
		);
	}

	@Action(Permissions.UpdateUserPermissions)
	updateUserPermissions(ctx: StateContext<PermissionsStateModel>, action: Permissions.UpdateUserPermissions) {
		ctx.patchState({
			loadingByUser: true,
		});
		return this.permissionsService.updateUserPermissions(action.userId, action.permissions).pipe(
			tap((returnData: any) => {
				const updated = returnData.data;
				const state = ctx.getState();
			}),
			finalize(() => {
				ctx.patchState({
					loadingByUser: false,
				});
			})
		);
	}
}
